import * as _ from "lodash";
import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse } from "@nkr/models/index";
import { IAlleleOverride } from "@nkr/models/hla";

export interface IAlleleOverrideResponse {
    data: {
        success: boolean,
        results: IAlleleOverride[]
    }
}

export const ActionCreators = {
    getAlleleOverrides: () => (dispatch: Dispatch<IApplicationState>): Promise<IAlleleOverrideResponse> => {
        var options = {
            url: __API__ + "/hla-allele/new-alleles"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IAlleleOverrideResponse) => {
            return Promise.resolve(response);
        });
    }
};
